import { Chip, Icon } from "@legal-500/legal500-design-system";
import type { ApprovalRequest } from "../../../../api/approvalRequests.service";
import { formatDateTime } from "@/utils";
import { mapStatus, parseTransformations } from "../utils";
import { SentimentChip } from "../../components/SentimentChip";
import styles from "./StatusColumn.module.css";

type StatusColumnProps = {
  item: ApprovalRequest;
};

export function StatusColumn({ item }: StatusColumnProps) {
  const status = mapStatus(item.status);
  const filters = parseTransformations(item.transformations);

  const getStatusBadge = () => {
    switch (status) {
      case "NEW":
        return (
          <Chip size="small" variant="filled" className={styles.statusBadgeNew}>
            ▲ New
          </Chip>
        );
      case "APPROVED":
        return (
          <Chip size="small" variant="filled" className={styles.statusBadgeApproved}>
            ✓ Approved
          </Chip>
        );
      case "REJECTED":
        return (
          <Chip size="small" variant="filled" className={styles.statusBadgeRejected}>
            ✗ Rejected
          </Chip>
        );
      case "SUSPENDED":
        return (
          <Chip size="small" variant="filled" className={styles.statusBadgeSuspended}>
            ⏸ Suspended
          </Chip>
        );
      case "WITHDRAWN":
        return (
          <Chip size="small" variant="filled" className={styles.statusBadgeWithdrawn}>
            ↩ Withdrawn
          </Chip>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.statusColumn}>
      <div className={styles.statusBadgeContainer}>
        <span className={styles.statusLabel}>Status:</span>
        {getStatusBadge()}
      </div>
      <div className={styles.statusBadgeContainer}>
        <span className={styles.statusLabel}>Sentiment:</span>
        <SentimentChip sentiment={item.sentiment} />
      </div>
      {filters.length > 0 && (
        <div className={styles.filtersSection}>
          <span className={styles.filtersLabel}>Filters:</span>
          <div className={styles.filtersContainer}>
            {filters.map((filter, index) => (
              <Chip key={index} size="small" variant="outlined" className={styles.filterChip}>
                {filter}
              </Chip>
            ))}
          </div>
        </div>
      )}
      <div className={styles.updatedContainer}>
        <div className={styles.updatedDate}>
          <span className={styles.updatedLabel}>Updated:</span>{" "}
          <span className={styles.updatedValue}>
            {(() => {
              const dateToFormat = item.updatedAt;
              return dateToFormat ? formatDateTime(dateToFormat) : "-";
            })()}
          </span>
        </div>
      </div>
      <div className={styles.updatedContainer}>
        <div className={styles.updatedDate}>
          <span className={styles.updatedLabel}>Created:</span>{" "}
          <span className={styles.updatedValue}>
            {(() => {
              const dateToFormat = item.originalCreatedAt;
              return dateToFormat ? formatDateTime(dateToFormat) : "-";
            })()}
          </span>
        </div>
      </div>
    </div>
  );
}
